import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PROVIDER_DETAIL = 'GET_PROVIDER_DETAIL';
export const GET_PROVIDER_DETAIL_SUCCESS = 'GET_PROVIDER_DETAIL_SUCCESS';
export const GET_PROVIDER_DETAIL_FAILURE = 'GET_PROVIDER_DETAIL_FAILURE';

// Action Creators
export const getProviderDetail = () => ({
  type: GET_PROVIDER_DETAIL,
});

export const getProviderDetailSuccess = (users) => ({
  type: GET_PROVIDER_DETAIL_SUCCESS,
  payload: users,
});

export const getProviderDetailFailure = (error) => ({
  type: GET_PROVIDER_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getProviderDetailData = (external, id) => {
  return async (dispatch) => {
    dispatch(getProviderDetail());
    try {
      const response = await getMethodWithToken(
        url?.getProviderDetail + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getProviderDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getProviderDetailFailure('error?.message'));
      }
    } catch (error) {
      dispatch(getProviderDetailFailure(error?.message));
    }
  };
};
